import {ActivatedRouteSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {RequestExecutor} from '../../../util/request-executor';

@Injectable()
export class UserListResolver {
  constructor(private request: RequestExecutor) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const page = route.queryParams['page'];

    console.log('Resolving user list page ' + page);

    let offset = 0;

    if (page !== undefined) {
      offset = 20 * (+page - 1);
    }

    return this.request.get('/users', {offset: offset, count: 20});
  }
}
